import { proxy } from 'valtio'
import { closeNavAuthDropdown } from './utopiaAuthState'

export const utopiaOverlayState = proxy({
  cguOpen: false,
  legalOpen: false,
})

function closeOtherOverlays (except?: 'cgu' | 'legal') {
  if (except !== 'cgu') utopiaOverlayState.cguOpen = false
  if (except !== 'legal') utopiaOverlayState.legalOpen = false
  closeNavAuthDropdown()
}

export function openUtopiaCguModal () {
  closeOtherOverlays('cgu')
  utopiaOverlayState.cguOpen = true
}

export function closeUtopiaCguModal () {
  utopiaOverlayState.cguOpen = false
}

export function openUtopiaLegalModal () {
  closeOtherOverlays('legal')
  utopiaOverlayState.legalOpen = true
}

export function closeUtopiaLegalModal () {
  utopiaOverlayState.legalOpen = false
}
